import { getLocalStorageService } from "@/infrastructure/di/services";
import { PAGINATION_STORAGE_KEY, usePaginationStore } from "@/stores/usePaginationStore";

/**
 * Migrates the legacy items-per-page value (a bare number written by the old
 * PaginationStorageService) to the zustand persist envelope, then hydrates
 * the store (created with skipHydration so this runs first).
 */
export function initPaginationStore() {
  const storage = getLocalStorageService();
  const stored = storage.get<unknown>(PAGINATION_STORAGE_KEY);
  if (typeof stored === "number" && Number.isFinite(stored) && stored > 0) {
    storage.set(PAGINATION_STORAGE_KEY, { state: { itemsPerPage: stored }, version: 0 });
  }
  void usePaginationStore.persist.rehydrate();
}
